// extracted by mini-css-extract-plugin
module.exports = {"img":"CardDogs_img__10BQP","text":"CardDogs_text__3MGz8","paf":"CardDogs_paf__H0bMO","paf2":"CardDogs_paf2__1uz-N","button":"CardDogs_button__TN9oC"};